<template>
  <v-select
    filled
    :hide-details="!isRequired"
    :label="title"
    :items="fields"
    :rules="rules"
    :value="value"
    @input="onInput"
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";

export default {
  name: "ServerValueSourcePicker",

  props: ["title", "isRequired", "value"],

  data() {
    return {
      fields: ["data", "variable", "function", "value"],
    };
  },

  computed: {
    rules() {
      return this.isRequired
        ? ui.requiredRules(this.$store.getters.required)
        : [];
    },
  },

  methods: {
    onInput(e) {
      this.$emit("input", e);
    },
  },
};
</script>